var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThirdImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 170,
    viewBox: "0 0 206 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.84 26H92.1401C90.7601 26 89.6401 27.12 89.6401 28.5C89.6401 29.88 90.7601 31 92.1401 31H103.99V37.79C103.99 39.17 105.11 40.29 106.49 40.29C107.87 40.29 108.99 39.17 108.99 37.79V31H120.84C122.22 31 123.34 29.88 123.34 28.5C123.34 27.12 122.22 26 120.84 26Z",
    fill: "#EDFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.04 36.02C91.9901 35 75.6901 42.86 65.1001 55.61H71.8401C81.7301 45.6 95.8601 39.78 111.29 41.11C135.85 43.24 155.26 63.65 156.23 88.29C157.34 116.4 134.79 139.62 106.92 139.62C93.3701 139.62 81.0901 134.13 72.1601 125.26H65.3801C75.3601 137.09 90.2701 144.62 106.92 144.62C137.64 144.62 162.48 119.01 161.22 88.02C160.11 60.27 137.78 37.57 110.04 36.02Z",
    fill: "#1C1A1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.66 71.61H41.21C39.83 71.61 38.71 70.49 38.71 69.11C38.71 67.73 39.83 66.61 41.21 66.61H81.66C83.04 66.61 84.16 67.73 84.16 69.11C84.16 70.49 83.04 71.61 81.66 71.61Z",
    fill: "#EDFF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.41 92.78H26.5C25.12 92.78 24 91.66 24 90.28C24 88.9 25.12 87.78 26.5 87.78H75.41C76.79 87.78 77.91 88.9 77.91 90.28C77.91 91.66 76.79 92.78 75.41 92.78Z",
    fill: "#EDFF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.73 113.94H37.21C35.83 113.94 34.71 112.82 34.71 111.44C34.71 110.06 35.83 108.94 37.21 108.94H67.73C69.11 108.94 70.23 110.06 70.23 111.44C70.23 112.82 69.11 113.94 67.73 113.94Z",
    fill: "#EDFF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.05 69.12C126.07 68.14 124.49 68.14 123.51 69.12L108.27 84.37C107.68 84.19 107.06 84.09 106.42 84.09C102.92 84.09 100.09 86.93 100.09 90.42C100.09 93.77 102.69 96.51 105.99 96.73L120.16 129.35C120.57 130.29 121.49 130.85 122.45 130.85C122.78 130.85 123.12 130.78 123.45 130.64C124.72 130.09 125.3 128.62 124.75 127.35L110.71 95.07C111.96 93.91 112.75 92.26 112.75 90.42C112.75 89.41 112.51 88.46 112.09 87.61L127.05 72.65C128.03 71.68 128.03 70.1 127.05 69.12Z",
    fill: "#1C1A1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdImage);
export default __webpack_public_path__ + "static/media/third_image.cca788443762eb6e08d92ef5a721d4e6.svg";
export { ForwardRef as ReactComponent };